import { Link } from 'react-router';
import { Brand } from '../components/Brand';

export default function NotFoundPage() {
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-6 p-8 text-center">
      <Brand />
      <h1 className="text-4xl font-extrabold">Page not found</h1>
      <p className="text-ink-soft">The page you are looking for does not exist.</p>
      <div className="flex gap-3">
        <Link to="/" className="rounded-xl bg-g-blue px-5 py-3 font-bold text-white">
          Join a game
        </Link>
        <Link to="/host" className="rounded-xl border border-line bg-surface px-5 py-3 font-bold">
          Host a quiz
        </Link>
      </div>
    </main>
  );
}
